var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  viewBox: "-2 -2 26.4 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "icon-linkedin_svg__a",
  d: "M21.64 12.431c2.926 0 5.225 1.877 5.225 5.917V25.6h-4.668v-6.75c0-1.766-.73-2.973-2.336-2.973-1.228 0-1.91.815-2.228 1.599-.12.282-.101.674-.101 1.066V25.6h-4.624s.06-11.956 0-13.043h4.624v2.047c.273-.895 1.75-2.173 4.109-2.173zm-15.363.126h4.117V25.6H6.277V12.557zM8.26 6.4c1.52 0 2.453.974 2.483 2.26 0 1.264-.964 2.265-2.511 2.265H8.2c-1.49 0-2.456-.997-2.456-2.26 0-1.289.994-2.265 2.514-2.265z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  fillRule: "evenodd",
  transform: "translate(-5 -6)",
  xlinkHref: "#icon-linkedin_svg__a"
})));
export default SvgIconLinkedin;